var baseUrl = 'http://localhost:8066/api/gxdjk-server-b';
var serverUrl = 'https://test-gxdjk-manager.houchangtech.com/api'
var DEBUG = false

if (process.env.NODE_ENV === 'development') {
    baseUrl = 'https://test-gxdjk.houchangtech.com/api/gxdjk-server-b' // 本地
    DEBUG = false
} else if (process.env.NODE_ENV === 'testing') {
    baseUrl = 'https://test-gxdjk.houchangtech.com/api/gxdjk-server-b'
    serverUrl = 'https://test-gxdjk-manager.houchangtech.com/api'
    DEBUG = false
} else if (process.env.NODE_ENV === 'production') {
    baseUrl = 'https://www.gxdjk.cn/api/gxdjk-server-b'
    serverUrl = 'https://manager.gxdjk.cn/api'
    DEBUG = false
}
export {
    baseUrl,
    DEBUG,
    serverUrl
}
